import React, { useState } from 'react';
import { Dialog, Button } from "@abb/abb-common-ux-react";
import './PageInfoDialog.css';
import pageInfoConfig from '../../config/pageInfoConfig.json';

const PageInfoDialog = ({ pageData, pageKey }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  // Check if info icons are enabled globally and for this specific page
  const isGloballyEnabled = pageInfoConfig.globalSettings.enabled;
  const isPageEnabled = pageKey && pageInfoConfig.pages[pageKey]?.enabled !== false;
  const shouldShowIcon = isGloballyEnabled && isPageEnabled;

  // If disabled, don't render anything
  if (!shouldShowIcon) {
    return null;
  }

  return (
    <>
      {/* Info Icon Button */}
      <button 
        className="page-info-icon-button"
        onClick={handleOpen}
        title="Page Information"
        aria-label="Show page information"
      >
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="12" cy="8" r="1" fill="currentColor"/>
        </svg>
      </button>

      {/* Info Dialog */}
      {isOpen && (
        <Dialog
          heading={pageData.title}
          isOpen={isOpen}
          onClose={handleClose}
          className="page-info-dialog"
        >
          <div className="page-info-content">
            {/* Overview Section */}
            <section className="info-section">
              <h3 className="info-section-title">📋 Overview</h3>
              <p className="info-description">{pageData.overview}</p>
            </section>

            {/* Before Problem Section */}
            {pageData.beforeProblem && (
              <section className="info-section problem-section">
                <h3 className="info-section-title">⚠️ Previous Challenges</h3>
                <ul className="info-list">
                  {pageData.beforeProblem.map((problem, index) => (
                    <li key={index}>{problem}</li>
                  ))}
                </ul>
              </section>
            )}

            {/* Enhancement Section */}
            {pageData.enhancement && (
              <section className="info-section enhancement-section">
                <h3 className="info-section-title">✨ Current Enhancements</h3>
                <ul className="info-list">
                  {pageData.enhancement.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </section>
            )}

            {/* How It Helps Section */}
            {pageData.howItHelps && (
              <section className="info-section help-section">
                <h3 className="info-section-title">💡 How It Helps</h3>
                <ul className="info-list">
                  {pageData.howItHelps.map((help, index) => (
                    <li key={index}>{help}</li>
                  ))}
                </ul>
              </section>
            )}

            {/* Key Features Section */}
            {pageData.keyFeatures && (
              <section className="info-section features-section">
                <h3 className="info-section-title">🎯 Key Features</h3>
                <ul className="info-list">
                  {pageData.keyFeatures.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </section>
            )}
          </div>

          {/* Footer with Close Button */}
          <div className="dialog-footer">
            <Button
              text="Close"
              onClick={handleClose}
              shape="pill"
              type="primary"
            />
          </div>
        </Dialog>
      )}
    </>
  );
};

export default PageInfoDialog;
